export const cultural_legislation = [
  {
    id: 1,
    name: 'provincal lanuage act,1998',
    summary: 'shortsummary/provincal lanuage act,1998.html',
    link: 'provincal lanuage act,1998.pdf',
    audio_en: 'audio/en/provincal lanuage act,1998_en.mp3',
    audio_af: 'audio/af/provincal lanuage act,1998_af.mp3',
    audio_xh: 'audio/xh/provincal lanuage act,1998_xh.mp3'
  },
  {
    id: 2,
    name: 'western cape cultural commission and cultural councils act,1998',
    summary: 'shortsummary/western cape cultural commission and cultural councils act,1998.html',
    link: 'western cape cultural commission and cultural councils act,1998.pdf',
    audio_en: 'audio/en/western cape cultural commission and cultural councils act,1998_en.mp3',
    audio_af: 'audio/af/western cape cultural commission and cultural councils act,1998_af.mp3',
    audio_xh: 'audio/xh/western cape cultural commission and cultural councils act,1998_xh.mp3'
  }
];